import en from './en';
import am from './am';
import or from './or';

const translations = { en, am, or };

export { translations };
export default translations;
